<template>
    <div class="select_dialog_embed" @click="closePage()">
      <div v-if="showType !== 'costPrice'" class="order_list_embed_msg"
           :class="{'w_percent96' : (showType === 'changeGoods' || showType === 'splitOrder'), 'w_percent85' : showType === 'orderDetail'}">
        <div class="select_dialog_embed_box">
          <!--弹出框头部-->
          <div class="select_dialog_embed_box_top">
            <p>{{title}}</p>
          </div>

          <!--弹出框信息-->
          <!--合并订单-->
          <div v-if="showType === 'mergerOrder'" class="select_dialog_embed_box_content merger_order">
            <p>请确定是否进行订单合并？</p>
            <p>注：订单合并条件必须为同店铺，同收货信息，同客户Id，同配货渠道，订单状态为”待审“未产生售后的订单才可进行合单操作</p>
          </div>

          <!--批量审单/审单-->
          <div v-if="showType === 'batchAudit' && txtMsg" class="select_dialog_embed_box_content batch_audit">
            <p v-if="isBatch">请确定是否进行批量订单审核并交单给渠道进行发货操作？</p>
            <p v-if="!isBatch">请确定是否进行订单审核并交单给渠道进行发货操作？？</p>
          </div>

          <!--单个复制-->
          <div v-if="showType === 'copyOrder'" class="select_dialog_embed_box_content batch_audit">
            <p>是否进行复制操作？</p>
          </div>

          <!--部分审单失败-->
          <div v-if="(showType === 'batchAudit' || showType === 'aCheckList') && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content batch_audit_fail">
            <p class="ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--批量同步订单的线上发货信息-->
          <div v-if="showType === 'syncOnlineOrderSend'" class="select_dialog_embed_box_content merger_order mt50">
            <p>请确定是否将选择到的订单进行批量同步订单的线上发货信息？</p>
          </div>

          <!--批量撤回-->
          <div v-if="showType === 'batchPullBack'" class="select_dialog_embed_box_content merger_order mt50">
            <p>请确定是否将选择到的订单进行批量批量撤回？</p>
          </div>

          <!--批量付款/全部付款-->
          <div v-if="(showType === 'batchPayment' || showType === 'allPayment') && txtMsg" class="select_dialog_embed_box_content text_center pt20 pb10">
            <p v-if="showType === 'batchPayment'">确定对已勾选订单进行批量付款操作？</p>
            <p v-if="showType === 'allPayment'">确定对全部待付款订单进行批量付款操作？</p>
            <div class="mt10">
              <span>安全密码：</span>
              <div class="inb">
                <input type="password" title="安全密码加密" maxlength="20" v-model.trim="securityCode">
              </div>
            </div>
          </div>

          <!--部分批量付款/全部付款失败-->
          <div v-if="(showType === 'batchPayment' || showType === 'allPayment') && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content batch_audit_fail">
            <!--<p class="ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>-->
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--激活订单-->
          <div v-if="showType === 'activationOrder' && txtMsg" class="select_dialog_embed_box_content">
            <p v-if="isBatch" class="mt30 mb30 ml40">请确定是否进行批量订单激活操作？</p>
            <p v-if="!isBatch" class="mt30 mb30 ml40">请确定是否对当前选中订单进行激活操作？</p>
          </div>

          <!--激活订单部分失败-->
          <div v-if="showType === 'activationOrder' && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content batch_audit_fail">
            <p class="ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--取消订单-->
          <div v-if="showType === 'cancelOrder' && txtMsg" class="select_dialog_embed_box_content">
            <p v-if="isBatch" class="mt30 mb30 ml40">请确定是否进行批量订单取消操作？</p>
            <p v-if="!isBatch" class="mt30 mb30 ml40">请确定是否要取消订单？</p>
          </div>

          <!--取消订单部分失败-->
          <div v-if="showType === 'cancelOrder' && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content batch_audit_fail">
            <p class="ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--渠道重配-->
          <div v-if="showType === 'channelOrder' && txtMsg" class="select_dialog_embed_box_content">
            <p v-if="isBatch" class="mt30 mb30 ml40">请确定是否进行批量渠道重配操作？</p>
            <p v-if="!isBatch" class="mt30 mb30 ml40">请确定是否进行渠道重配？</p>
          </div>

          <!--渠道重配--部分失败-->
          <div v-if="showType === 'channelOrder' && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content channel_order_failed">
            <p class="mt10 mr10 ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrorContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--添加货品-->
          <div v-if="showType === 'addOrder' && txtMsg" class="select_dialog_embed_box_content add_order">
            <div class="mt10 mb10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <th>颜色</th>
                  <th>尺码</th>
                  <th>数量</th>
                  <th class="w90">操作</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-if="goodsDetailList.length" v-for="(item, index) in goodsDetailList" :key="index">
                  <td><input v-model.trim="item.GoodsId" maxlength="50" type="text" title="货号"></td>
                  <td><input v-model.trim="item.ColorAlias" maxlength="50" type="text" title="颜色"></td>
                  <td><input v-model.trim="item.Size" maxlength="50" type="text" title="尺码"></td>
                  <td><input v-model.trim="item.Quantity" maxlength="10" @blur="quantityInteger($event, index)" type="text" title="数量"></td>
                  <td class="w90">
                    <div>
                      <a title="删除" @click="delGoodsDetail(index)">删除</a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="text_right mt10 mb20">
                <a class="fcLinkA" title="添加明细" @click="addGoodsDetail()">添加明细</a>
              </div>
            </div>
          </div>

          <!--添加货品部分失败-->
          <div v-if="showType === 'addOrder' && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content channel_order_failed">
            <p class="mt10 mr10 ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--备注-->
          <div v-if="showType === 'remarks' && txtMsg" class="select_dialog_embed_box_content seller_remark">
            <div class="mb10">
              <span>旗帜：</span>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="红" value="1"><img src="../../../assets/img/flag_red.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="黄" value="2"><img src="../../../assets/img/flag_yellow.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="绿" value="3"><img src="../../../assets/img/flag_green.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="蓝" value="4"><img src="../../../assets/img/flag_blue.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="紫" value="5"><img src="../../../assets/img/flag_purple.png" height="12" width="12"/></div>
            </div>
            <div class="mb10">
              <span class="fl">卖家备注：</span>
              <textarea title="卖家备注" v-model.trim="sellerRemarks"></textarea>
            </div>
            <div class="mb10">
              <span class="fl">内部备注：</span>
              <textarea title="内部备注" v-model.trim="internalRemarks"></textarea>
            </div>
          </div>

          <!--卖家备注-->
          <div v-if="showType === 'sellerRemarks' && txtMsg" class="select_dialog_embed_box_content seller_remark">
            <div class="mb10">
              <span>旗帜：</span>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="红" value="1"><img src="../../../assets/img/flag_red.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="黄" value="2"><img src="../../../assets/img/flag_yellow.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="绿" value="3"><img src="../../../assets/img/flag_green.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="蓝" value="4"><img src="../../../assets/img/flag_blue.png" height="12" width="12"/></div>
              <div class="inb"><input v-model="flagColor" type="radio" name="flags" title="紫" value="5"><img src="../../../assets/img/flag_purple.png" height="12" width="12"/></div>
            </div>
            <div class="mb10">
              <span class="fl">备注：</span>
              <textarea title="备注" v-model.trim="sellerRemarks"></textarea>
            </div>
            <div v-if="isBatch" class="mb10">
              <span>模式：</span>
              <div class="inb"><input v-model="modeType" type="radio" name="mode" id="seller_remark_cover" title="覆盖" value="1"><label for="seller_remark_cover">覆盖</label></div>
              <div class="inb"><input v-model="modeType" type="radio" name="mode" id="seller_remark_append" title="追加" value="2"><label for="seller_remark_append">追加</label></div>
            </div>
            <div v-if="isBatch">注：覆盖模式为覆盖所选订单的卖家备注，追加为在所选订单的备注后面进行备注追加。</div>
          </div>

          <!--卖家备注部分失败-->
          <div v-if="showType === 'sellerRemarks' && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content channel_order_failed">
            <p class="mt10 mr10 ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--内部备注-->
          <div v-if="showType === 'internalRemarks' && txtMsg" class="select_dialog_embed_box_content internal_remarks">
            <div class="mb10">
              <span class="fl">备注：</span>
              <textarea title="备注" v-model.trim="internalRemarks"></textarea>
            </div>
            <div v-if="isBatch" class="mb10">
              <span>模式：</span>
              <div class="inb"><input v-model="modeType" type="radio" name="mode" id="internal_remarks_cover" title="覆盖" value="1"><label for="internal_remarks_cover">覆盖</label></div>
              <div class="inb"><input v-model="modeType" type="radio" name="mode" id="internal_remarks_append" title="追加" value="2"><label for="internal_remarks_append">追加</label></div>
            </div>
            <div v-if="isBatch">注：覆盖模式为覆盖所选订单的内部备注，追加为在所选订单的备注后面进行备注追加。</div>
          </div>

          <!--内部备注部分失败-->
          <div v-if="showType === 'internalRemarks' && !isMsg && !isSuc && !txtMsg" class="select_dialog_embed_box_content channel_order_failed">
            <p class="mt10 mr10 ml10">注：除错误列表订单操作失败外其他订单已操作成功</p>
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>订单号</th>
                  <th>错误信息</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--订单详情-->
          <div v-if="showType === 'orderDetail'" class="select_dialog_embed_box_content order_detail">
            <div v-if="orderDetail" class="order_detail_content">
              <table class="table tb_border">
                <tr>
                  <th>内部订单号:</th>
                  <td>{{orderDetail.OrderId}}</td>
                  <th>平台订单号:</th>
                  <td>{{orderDetail.OutOrderId}}</td>
                  <th>下单时间:</th>
                  <td>{{orderDetail.OrderCreateTime | time}}</td>
                  <th>付款时间:</th>
                  <td>{{orderDetail.PayTime | time}}</td>
                </tr>
                <tr>
                  <th>订单金额:</th>
                  <td>{{orderDetail.PaymentAmount}}元</td>
                  <th>优惠金额:</th>
                  <td>{{orderDetail.OfferAmount}}元</td>
                  <th>货品金额:</th>
                  <td>{{orderDetail.TotalAmount}}元</td>
                  <th>运费金额:</th>
                  <td>{{orderDetail.PostAmount}}元</td>
                </tr>
                <tr>
                  <th>店铺:</th>
                  <td>{{orderDetail.ShopName}}</td>
                  <th>买家ID:</th>
                  <td>{{orderDetail.BuyerNick}}
                    <a v-if="orderDetail.ShopSource === 1 || orderDetail.ShopSource === 2" target="view_window"
                       :href="'https://www.taobao.com/go/market/webww/ww.php?spm=a1z10.1-b.w5003-9865995892.19.Y9DW3r&ver=3&touid=' + orderDetail.BuyerNick + '&siteid=cntaobao&status=1&charset=utf-8&scene=taobao_shop'">
                      <img src="../../../assets/img/ww.png" title="旺旺" height="20" width="20"/></a>
                  </td>
                  <th>买家备注:</th>
                  <td colspan="3">{{orderDetail.BuyerMessage}}</td>
                </tr>
                <tr>
                  <th>卖家备注:</th>
                  <td colspan="2">{{orderDetail.SellerMemo}}</td>
                  <th>系统备注:</th>
                  <td colspan="2">{{orderDetail.SysMemo}}</td>
                  <th>内部备注:</th>
                  <td>{{orderDetail.AgentRemark}}</td>
                </tr>
              </table>

              <table class="table tb_border mt10">
                <tr>
                  <th>状态:</th>
                  <td>{{orderDetail.SysStatusName}}</td>
                  <th>渠道:</th>
                  <td>{{orderDetail.StoreroomCodeName}}</td>
                  <!--<td v-if="orderDetail.StoreroomName">{{orderDetail.SupplierCode}}_{{orderDetail.StoreroomName}}</td>-->
                  <!--<td v-if="!orderDetail.StoreroomName"></td>-->
                  <th>交单时间:</th>
                  <td>{{orderDetail.DeliveryTime | time}}</td>
                  <th>发货时间:</th>
                  <td>{{orderDetail.SupplySendTime | time}}</td>
                </tr>
                <tr>
                  <th>交单货款:</th>
                  <td>{{orderDetail.OrderCost}}元</td>
                  <th>实发货款:</th>
                  <td>{{orderDetail.SendOrderCost}}元</td>
                  <th>交单运费:</th>
                  <td>{{orderDetail.CourierFee}}元</td>
                  <th>实发运费:</th>
                  <td>{{orderDetail.SendCourierFee}}元</td>
                </tr>
                <tr>
                  <!--<th>快递公司:</th>-->
                  <!--<td>{{orderDetail.LogisticName}}</td>-->
                  <th>实发物流:</th>
                  <td>{{orderDetail.SendLogisticName}}</td>
                  <th>快递单号:</th>
                  <td>{{orderDetail.ExpressNum}}</td>
                  <th>交单物流:</th>
                  <td>{{orderDetail.LogisticName}}</td>
                  <th></th>
                  <td></td>
                </tr>
                <tr>
                  <th>收货信息:</th>
                  <td colspan="7">{{orderDetail.ReceiveName}},
                    {{orderDetail.Phone}},
                    {{orderDetail.ProvinceName}}{{orderDetail.CityName}}{{orderDetail.AreaName}}{{orderDetail.Address}},{{orderDetail.PostCode}}
                    <!--{{orderDetail.CityName}}{{orderDetail.AreaName}}&nbsp;
                    {{orderDetail.Address}}&nbsp;-->
                  </td>
                </tr>
              </table>
            </div>
            <div class="mt10 mb10 order_detail_goods">
              <table class="table tb_border">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <!--<th>品名</th>-->
                  <th>颜色</th>
                  <th>尺码</th>
                  <th>零售价</th>
                  <!--<th>单价</th>-->
                  <th>数量</th>
                  <!--<th>优惠</th>-->
                  <th>销售合计</th>
                  <th>成本单价</th>
                  <th>成本折扣</th>
                  <th>成本价合计</th>
                  <th>实发数量</th>
                  <th id="fixed_th" style="width: calc(77px + 0.45em)!important;">实发金额</th>
                </tr>
                </thead>
              </table>
              <table class="table tb_border detail_tb">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-if="orderDetail.AgentDetailList" v-for="(item, index) in orderDetail.AgentDetailList" :key="index">
                  <td>{{item.GoodsId}}</td>
                  <!--<td>{{item.GoodsName}}</td>-->
                  <td>{{item.ColorName}}</td>
                  <td>{{item.Size}}</td>
                  <td>{{item.MarkPrice}}</td>
                  <!--<td>{{item.UnitPrice}}</td>-->
                  <td>{{item.Quantity}}</td>
                  <!--<td>{{item.OfferFee}}</td>-->
                  <td>{{item.sumPrice}}</td> <!-- 合计 = 单价*数量-优惠 -->
                  <td>{{item.AgentCostPrice}}</td>
                  <td>{{item.CostDiscount}}</td>
                  <td>{{item.sumAgentCostPrice}}</td> <!-- 成本价合计 = 成本单价*数量 -->
                  <td>{{item.SendQuantity}}</td>
                  <td style="width: 66px !important;">{{item.sumSendPrice}}</td> <!-- 实发金额 = 成本单价*实发数量 -->
                </tr>
                <tr>
                  <!--<td></td>-->
                  <!--<td></td>-->
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td class="text_right">合计</td>
                  <!--<td>{{orderDetail.totalOfferFee}}</td>-->
                  <td>{{orderDetail.total}}</td>
                  <td></td>
                  <td></td>
                  <td>{{orderDetail.totalAgentCostPrice}}</td>
                  <td>{{orderDetail.totalSendQuantity}}</td>
                  <td style="width: 66px !important;">{{orderDetail.totalSendPrice}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--订单明细库存信息-->
          <div v-if="showType === 'orderDetailInventory'" class="select_dialog_embed_box_content pl10 pr10">
            <div v-for="(item, index) in goodInventoryMsg" :key="index">
              <div class="mt10 mb10 ml10 mr10">
                <label class="fwb">货号：</label>
                <span class="fwb fcDel mr10">{{item.DetailInfo.GoodsId}}</span>
                <label class="fwb">颜色：</label>
                <span class="fwb fcDel mr10">{{item.DetailInfo.ColorName}}</span>
                <label class="fwb">尺码：</label>
                <span class="fwb fcDel mr10">{{item.DetailInfo.Size}}</span>
                <label class="fwb">零售价：</label>
                <span class="fwb fcDel mr10">{{item.DetailInfo.MarkPrice}}</span>
                <label class="fwb">订单数量：</label>
                <span class="fwb fcDel">{{item.DetailInfo.Quantity}}</span>
              </div>
              <table class="table tb_border maxH_400">
                <thead>
                <tr>
                  <th>渠道名称</th>
                  <th>库存</th>
                  <th>代理折扣</th>
                  <th>配货率(%)</th>
                  <th>渠道发货时间</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(itemIndex, index) in item.StoreroomList" :key="index">
                  <td>{{itemIndex.StoreroomName}}</td>
                  <td>{{itemIndex.Stock}}</td>
                  <td>{{itemIndex.CostDiscount}}</td>
                  <td>{{itemIndex.RealSendRate}}</td>
                  <td>{{itemIndex.ShipTime | timeday}}</td>
                </tr>
                </tbody>
              </table>
            </div>
            <p class="fcBlue">温馨提示：订单改仓功能中展示的可选择渠道已按代理折扣进行了排序，排在最前的为折扣最低的。</p>
          </div>

          <!--修改物流--待审-->
          <div v-if="showType === 'modifyLogisticPending'" class="select_dialog_embed_box_content">
            <div class="text_center mt40 mb40">
              <span>物流公司：</span>
              <div class="inb">
                <el-select v-model="selectCourierCompany" @change="getAllCityList" placeholder="物流公司">
                  <el-option
                    v-for="item in courierCompanyList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>

          <!--改仓-->
          <div v-if="showType === 'changeWarehouse'" class="select_dialog_embed_box_content change_warehouse">
            <div class="mt40">
              <el-select v-model.trim="selectChannelValue" @change="forChannelIdGetLogistic" placeholder="请选择">
                <el-option
                  v-for="item in channelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="mt20 mb40">
              <el-select v-model="selectCourierCompany" placeholder="请选择">
                <el-option
                  v-for="item in courierCompanyList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <!--改货-->
          <div v-if="showType === 'changeGoods'" class="select_dialog_embed_box_content change_goods">
            <div class="mb10 ml10">订单号：{{orderMsg.OrderId}}，订单总价：{{orderMsg.PaymentAmount}}，优惠：{{orderDetail.OfferAmount}}，运费：{{orderDetail.PostAmount}}，货品总价：<span class="fcDel">{{orderDetail.TotalAmount}}</span></div>
            <div class="mb10 ml10">买家留言：{{orderMsg.BuyerMessage}}</div>
            <div class="mb10 ml10">卖家备注：{{orderMsg.SellerMemo}}</div>
            <div class="mt10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <th>品名</th>
                  <th>颜色</th>
                  <th>尺码</th>
                  <th>零售价</th>
                  <th>成交单价</th>
                  <th>数量</th>
                  <th>优惠</th>
                  <th class="w40">操作</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-if="goodsDetailList.length" v-for="(item, index) in goodsDetailList" :key="index">
                  <td><input v-model.trim="item.GoodsId"
                             @blur="getGoodsInfoByGoodsId(item.GoodsId, index)"
                             @keyup.enter="getGoodsInfoByGoodsId(item.GoodsId, index)"
                             maxlength="50"
                             type="text" title="货号"></td>
                  <td>{{item.GoodsName}}</td>
                  <td><input v-model.trim="item.ColorAlias" maxlength="50" type="text" title="颜色"></td>
                  <td><input v-model.trim="item.Size" maxlength="50" type="text" title="尺码"></td>
                  <td>{{item.MarkPrice}}</td>
                  <td><input v-model.trim="item.UnitPrice" @blur="greaterThanZero(item.UnitPrice, index, 'price')" maxlength="20" type="text" title="成交单价"></td>
                  <td><input v-model.trim="item.Quantity" @blur="quantityInteger($event, index)" maxlength="10" type="text" title="数量"></td>
                  <td><input v-model.trim="item.OfferFee" @blur="greaterThanZero(item.OfferFee, index, 'discount')" maxlength="20" type="text" title="优惠"></td>
                  <!--<td class="w70">-->
                  <td class="w40">
                    <div>
                      <!--<a title="保存">保存</a>-->
                      <a v-if="!item.IsGeneration" title="删除" @click="delGoodsDetail(index)">删除</a>
                    </div>
                  </td>
                </tr>
                </tbody>
              </table>
              <div class="text_right mt10">
                <a class="fcLinkA" title="添加明细" @click="addGoodsDetail()">添加明细</a>
              </div>
            </div>
          </div>

          <!--拆单-->
          <div v-if="showType === 'splitOrder'" class="select_dialog_embed_box_content split_order">
            <div class="mb10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <th>品名</th>
                  <!--<th>颜色</th>-->
                  <th>尺码</th>
                  <th>数量</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(item, index) in orderDetail.AgentDetailList" :key="index">
                  <td>{{item.GoodsId}}</td>
                  <td>{{item.GoodsName}}</td>
                  <!--<td>{{item.ColorAlias}}</td>-->
                  <td>{{item.Size}}</td>
                  <td>{{item.Quantity}}</td>
                </tr>
                </tbody>
              </table>
              <div class="text_right mt10 mb20">
                <a class="fcLinkA" title="添加明细" @click="addSplitOrder()">添加新订单</a>
              </div>
            </div>
            <div class="mb10" v-for="(item, index) in splitOrderGroupList" :key="index">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <th>品名</th>
                  <!--<th>颜色</th>-->
                  <th>尺码</th>
                  <th>数量</th>
                  <th class="w70">操作</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr v-for="(childItem, childIndex) in item.goodsList" :key="childIndex">
                  <td>{{childItem.GoodsId}}</td>
                  <td>{{childItem.GoodsName}}</td>
                  <!--<td>{{childItem.ColorAlias}}</td>-->
                  <td>{{childItem.Size}}</td>
                  <td><input v-model.trim="childItem.Quantity"
                             @blur="positiveInteger($event, index, childIndex)"
                             maxlength="10"
                             type="text" title="数量"></td>
                  <td class="w70"><div><a title="删除" @click="delSplitOrder(index, childIndex)">删除</a></div></td>
                </tr>
                <!--<tr>
                  <td>假的货号</td>
                  <td>假的品名</td>
                  <td>假的颜色</td>
                  <td>假的尺码</td>
                  <td><input type="text" title="数量"></td>
                  <td class="w70"><div><a title="删除">删除</a></div></td>
                </tr>-->
                </tbody>
              </table>
            </div>
          </div>

          <!--合单详情-->
          <div v-if="showType === 'splitOrderDetail'" class="select_dialog_embed_box_content pt20 pr20 pl20">
            <div v-if="splitOrderDetailList" class="wMax600">
              <p class="mb10" v-html="'平台:' + (splitOrderDetailList.OperatContent).replace(/,/g, '</br>')">{{splitOrderDetailList.OperatContent}}</p>
              <p class="mb10" v-if="orderMsg.SplitJoinType === 2">拆单人：{{splitOrderDetailList.Operator}}，拆单时间：{{splitOrderDetailList.OperatTime | time}}</p>
              <p class="mb10" v-if="orderMsg.SplitJoinType === 4">合单人：{{splitOrderDetailList.Operator}}，合单时间：{{splitOrderDetailList.OperatTime | time}}</p>
            </div>
          </div>

          <!--智能拆单-->
          <div v-if="showType === 'intelligentSplitOrder'" class="select_dialog_embed_box_content pt20 pr40 pb10 pl40">
            <p>智能拆单会根据各个渠道库存对订单进行拆分，确保所有货品都能正常发出。</p>
            <p>请确定是否要进行智能拆单发货？</p>
          </div>

          <!--撤回-->
          <div v-if="showType === 'pullBack'" class="select_dialog_embed_box_content pt20 pr40 pb10 pl40">
            <p>请确定是否对当前选中订单进行撤回操作？</p>
          </div>

          <!--编辑收货信息-->
          <div v-if="showType === 'modifyReceivingInformation'" class="select_dialog_embed_box_content modify_receiving_information">
            <div>
              <span>收货人：</span>
              <div class="inb">
                <input v-model.trim="receiveName" maxlength="50" type="text" title="收货人" placeholder="收货人">
              </div>
            </div>
            <div>
              <span>联系电话：</span>
              <div class="inb">
                <input v-model.trim="phone" maxlength="30" type="text" title="联系电话" placeholder="联系电话">
              </div>
            </div>
            <div>
              <span>邮编：</span>
              <div class="inb">
                <input v-model.trim="postCode" maxlength="50" type="text" title="邮编" placeholder="邮编">
              </div>
            </div>
            <div>
              <span>省份：</span>
              <div class="inb">
                <el-select v-model="selectProvince" @change="getAllCityList" placeholder="省份">
                  <el-option
                    v-for="item in provincesList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <span>城市：</span>
              <div class="inb">
                <el-select v-model="selectCity" @change="getAllAreaList" placeholder="城市">
                  <el-option
                    v-for="item in cityList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <span>城区：</span>
              <div class="inb">
                <el-select v-model="selectArea" @change="getAreaName" placeholder="城区">
                  <el-option
                    v-for="item in areaList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div><span class="fl mr4">详细地址：</span><textarea v-model.trim="address" class="w_percent76 h80" title="详细地址"></textarea></div>
            <div class="text_right">
              <a class="fcLinkA" title="智能地址输入" @click="intelligentAddressEntry()">智能地址录入</a>
            </div>
          </div>

          <!--修改物流-->
          <div v-if="showType === 'modifyLogistic'" class="select_dialog_embed_box_content modify_receiving_information">
            <div>
              <span>物流公司：</span>
              <div class="inb">
                <el-select v-model="selectCourierCompany" @change="getAllCityList" placeholder="省份">
                  <el-option
                    v-for="item in courierCompanyList"
                    :key="item.id"
                    :label="item.text"
                    :value="item.id">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div>
              <span>运单号：</span>
              <div class="inb">
                <input v-model.trim="ExpressNum" maxlength="50" type="text" title="运单号" placeholder="运单号">
              </div>
            </div>
          </div>

          <!--缺货信息-->
          <div v-if="showType === 'outOfStockInformation'" class="select_dialog_embed_box_content out_of_stock_information">
            <div class="mt10 mr10 mb10 ml10">
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>货号</th>
                  <th>品名</th>
                  <th>颜色</th>
                  <th>尺码</th>
                  <th>数量</th>
                  <th>库存</th>
                </tr>
                </thead>
              </table>
              <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <tbody>
                <tr>
                  <td>假的货号</td>
                  <td>假的品名</td>
                  <td>假的颜色</td>
                  <td>假的尺码</td>
                  <td>假的数量</td>
                  <td>假的库存</td>
                </tr>
                <tr>
                  <td>假的货号</td>
                  <td>假的品名</td>
                  <td>假的颜色</td>
                  <td>假的尺码</td>
                  <td>假的数量</td>
                  <td>假的库存</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!--是否取消订单同步发货失败标记-->
          <div v-if="showType === 'synchronizationFailureFlag'" class="select_dialog_embed_box_content pt20 pr40 pb10 pl40">
            <p class="vertical_center"><i class="iconfont icon-fail mr10 fs30 fcDel"></i>确定取消订单同步发货失败标记？</p>
          </div>

          <!--日志-->
          <div v-if="showType === 'checkLog'" class="select_dialog_embed_box_content check_log">
            <div class="mt10 mr10 mb10 ml10">
             <!-- <table class="table">
                <colgroup><col style="width: 100%"></colgroup>
                <thead>
                <tr>
                  <th>操作人</th>
                  <th>操作内容</th>
                  <th>操作时间</th>
                </tr>
                </thead>
              </table> -->
              <table class="table tb_border">
                <!--<colgroup><col style="width: 100%"></colgroup>-->
                <thead>
                <tr>
                  <th>操作人</th>
                  <th>操作内容</th>
                  <th>操作时间</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in logList" :key="index">
                  <td>{{item.CreaterUserName}}</td>
                  <td style="max-width: 400px">{{item.Info}}</td>
                  <td>{{item.CreateTime | time}}</td>
                </tr>
                <!--<tr v-for="(item, index) in errorList" :key="index">
                  <td>{{item.OrderId}}</td>
                  <td>{{item.ErrContent}}</td>
                </tr>-->
                </tbody>
              </table>
            </div>
          </div>

          <!--对账导出-->
          <div v-if="showType === 'accountsExport'" class="select_dialog_embed_box_content">
            <div class="text_center mt40 mb30">
              <input type="radio" id="format_1" class="mr5 pointer" value=1 v-model="formatValue"><label class="mr40" for="format_1">格式1</label>
              <input type="radio" id="format_2" class="mr5 pointer" value=2 v-model="formatValue"><label for="format_2">格式2</label>
            </div>
          </div>

          <!--导出明细-->
          <div v-if="showType === 'detailExport'" class="select_dialog_embed_box_content">
            <div class="text_center mt40 mb30">
              <input type="radio" id="format_3" class="mr5 pointer" value=1 v-model="formatValue"><label class="mr40" for="format_3">格式1</label>
              <input type="radio" id="format_4" class="mr5 pointer" value=2 v-model="formatValue"><label for="format_4">格式2</label>
            </div>
          </div>

          <!--一键审单-->
          <div v-if="showType === 'aCheckList' && txtMsg" class="select_dialog_embed_box_content">
            <div class="text_center mt40 mb30">
              确定要对当前所有【待审】状态，并且已配仓库的订单进行审单吗？
            </div>
          </div>

          <!--弹出框底部-->
          <div class="select_dialog_embed_box_bottom" :class="{'text_center' : showType === 'orderDetailInventory'}">
            <button class="btn_normal mb10" v-if="showType === 'batchAuditFail'" @click="downloadUrlFun()">导出EXCEL</button>
            <!--改仓-->
            <button class="btn_normal mb10" v-if="showType === 'changeWarehouse'" @click="submitBtn()">确定</button>
            <!--修改物流-->
            <button class="btn_normal mb10" v-if="showType === 'modifyLogistic'" @click="submitBtn()">确定</button>
            <!--保存订单修改物流信息 -- 订单待审修改物流公司-->
            <button class="btn_normal mb10" v-if="showType === 'modifyLogisticPending'" @click="submitBtn()">确定</button>
            <!--拆单-->
            <button class="btn_normal mb10" v-if="showType === 'splitOrder'" @click="manualSplitOrder()">确定</button>
            <!--合并订单-->
            <button class="btn_normal mb10" v-if="showType === 'mergerOrder'" @click="submitBtn()">确定</button>
            <!--审单-->
            <button class="btn_normal mb10" v-if="showType === 'batchAudit' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'batchAudit' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--单个订单复制-->
            <button class="btn_normal mb10" v-if="showType === 'copyOrder'" @click="submitBtn()">确定</button>
            <!--批量付款/全部付款-->
            <button class="btn_normal mb10" v-if="(showType === 'batchPayment' || showType === 'allPayment') && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="(showType === 'batchPayment' || showType === 'allPayment') && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--激活订单-->
            <button class="btn_normal mb10" v-if="showType === 'activationOrder' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'activationOrder' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--改货-->
            <button class="btn_normal mb10" v-if="showType === 'changeGoods'" @click="submitBtn()">确定</button>
            <!--取消订单-->
            <button class="btn_normal mb10" v-if="showType === 'cancelOrder' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'cancelOrder' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--渠道重配-->
            <button class="btn_normal mb10" v-if="showType === 'channelOrder' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'channelOrder' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--添加货品-->
            <button class="btn_normal mb10" v-if="showType === 'addOrder' && txtMsg" @click="verifyAppendGoods()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'addOrder' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--备注(包含卖家+内部)-->
            <button class="btn_normal mb10" v-if="showType === 'sellerRemarks' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'sellerRemarks' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--卖家备注-->
            <button class="btn_normal mb10" v-if="showType === 'remarks' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'remarks' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--内部备注-->
            <button class="btn_normal mb10" v-if="showType === 'internalRemarks' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'internalRemarks' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <!--撤回-->
            <button class="btn_normal mb10" v-if="showType === 'pullBack'" @click="submitBtn()">确定</button>
            <!--智能拆单-->
            <button class="btn_normal mb10" v-if="showType === 'intelligentSplitOrder'" @click="submitBtn()">确定</button>
            <!--是否取消订单同步发货失败标记-->
            <button class="btn_normal mb10" v-if="showType === 'synchronizationFailureFlag'" @click="submitBtn()">确定</button>
            <!--编辑收货地址-->
            <button class="btn_normal mb10" v-if="showType === 'modifyReceivingInformation'" @click="submitBtn()">确定</button>
            <!--同步发货信息-->
            <button class="btn_normal mb10" v-if="showType === 'syncOnlineOrderSend'" @click="submitBtn()">确定</button>
            <!--批量撤回-->
            <button class="btn_normal mb10" v-if="showType === 'batchPullBack'" @click="submitBtn()">确定</button>
            <!--对账导出-->
            <button class="btn_normal mb10" v-if="showType === 'accountsExport'" @click="submitBtn()">确定</button>
            <!--导出明细-->
            <button class="btn_normal mb10" v-if="showType === 'detailExport'" @click="submitBtn()">确定</button>
            <!--一键审单-->
            <button class="btn_normal mb10" v-if="showType === 'aCheckList' && txtMsg" @click="submitBtn()">确定</button>
            <button class="btn_normal mb10" v-if="showType === 'aCheckList' && !isMsg && !isSuc && !txtMsg" @click="downloadUrlFun()">导出EXCEL</button>
            <button class="btn_cancel mb10" @click="cancelBtn(false)">关闭</button>
          </div>
        </div>
      </div>

      <!--成本价页面-->
      <div v-if="showType === 'costPrice'" class="order_list_embed_msg">
        <div class="pt20 pr40 pb20 pl40">成本价：{{costPrice}}</div>
      </div>

      <!--信息提示框-->
      <msg-dialog v-if="isMsg"
                  :is-suc="isSuc"
                  :txt="txtMsg" @closebtn="closeMsgDialog"></msg-dialog>

      <!--加载框-->
      <loading-dialog v-if="isLoading" :type="loadingType"></loading-dialog>

      <!--嵌入判断框-->
      <order-list-embed-msg-embed v-if="isEmbedDialog"
                                  :title="embedDialogTitle"
                                  :showType="embedDialogType"
                                  :order-msg="embedDialogMsg"
                                  @cancelbtn="getEmbedDialogMsg"></order-list-embed-msg-embed>
    </div>
</template>

<script>
  import MsgDialog from '../../public-component/msg-dialog';
  import OrderListEmbedMsgEmbed from './order-list-embed-msg-embed';
  import LoadingDialog from '../../public-component/loading-dialog';

  export default {
    name: 'order-list-embed-msg',
    /**
     *  title：  头部名
     *  showType:
     *  orderMsg: 订单信息
     * */
    props: ['title', 'showType', 'orderMsg', 'isBatch'],
    components: {MsgDialog, OrderListEmbedMsgEmbed, LoadingDialog},
    data() {
      return {
        // orderDetail: {Storeroom: {}, OrderDetail: []}, // 订单详情
        orderDetail: {
          OrderId: null, // 内部订单号
          OutOrderId: null, // 平台/外部订单号
          OrderCreateTime: null, // 下单时间
          PayTime: null, // 付款时间
          TotalAmount: null, // 订单金额
          OfferAmount: null, // 优惠金额
          PaymentAmount: null, // 成交金额
          PostAmount: null, // 运费金额
          ShopName: null, // 店铺
          BuyerNick: null, // 买家ID
          BuyerMessage: null, // 买家备注
          SellerMemo: null, // 卖家备注
          SysMemo: null, // 系统备注
          AgentRemark: null, // 内部备注
          SysStatusName: null, // 状态
          SupplierCode: null, // 渠道前缀 - 供应商编号
          StoreroomName: null, // 渠道名
          DeliveryTime: null, // 交单时间
          SupplySendTime: null, // 发货时间
          OrderCost: null, // 交单货款
          SendOrderCost: null, // 实发货款
          CourierFee: null, // 交单运费
          SendCourierFee: null, // 实发运费
          LogisticName: null, // 快递公司
          ExpressNum: null, // 快递单号
          AgentDetailList: [] // 货品列表
        }, // 订单详情
        goodsDetailList: [], // 货品明细列表
        courierCompanyList: [], // 快递公司下拉
        selectCourierCompany: '', // 选择的快递公司
        ExpressNum: null, // 运单号
        flagColor: '', // 旗帜颜色
        sellerRemarks: null, // 卖家备注
        internalRemarks: null, // 内部备注
        modeType: 1, // 模式类型
        channelList: [], // 渠道下拉列表
        selectChannelValue: '', // 选择的渠道列表
        splitOrderList: [], // 拆单的列表
        splitOrderGroupList: [], // 拆单的组数
        splitOrderDetailList: [], // 拆弹详情
        delIndex: '', // 删除的数组下标
        provincesList: [], // 省份下拉
        selectProvince: null, // 选择的省份
        selectProvinceName: null, // 选择的省份名
        cityList: [], // 城市下拉
        selectCity: null, // 选择的城市
        selectCityName: null, // 选择的城市名
        areaList: [], // 区下拉
        selectArea: null, // 选择的区
        selectAreaName: null, // 选择的区名
        address: null, // 详细地址
        intelligentAddress: null, // 智能地址信息
        costPrice: null, // 成本价
        receiveName: null, // 收货人信息
        phone: null, // 收货人联系方式
        postCode: null, // 邮编
        securityCode: null, // 安全密码
        errorList: [], // 错误信息列表
        downloadUrl: null, // 导出信息/下载地址
        goodInventoryMsg: [], // 获评明细库存
       /* goodInventoryMsg: {
          DetailInfo: null,
          StoreroomList: []
        }, // 获评明细库存 */
        goodInventoryMsgErrTxt: null,
        logList: [], // 日志列表
        formatValue: 1, // 对账导出格式    1=格式1    2=格式2
        isLoading: false, // 是否显示加载框
        loadingType: 'NOP', // 加载页面类型
        isMsg: false, // 信息框显示
        isSuc: false, // 是否成功
        txtMsg: '信息框内容', // 信息框内容
        isEmbedDialog: false, // 嵌入弹出框
        embedDialogTitle: null, // 嵌入弹出框头部
        embedDialogType: null, // 嵌入弹出框类型
        embedDialogMsg: null // 嵌入弹出框信息
      }
    },
    methods: {
      // 获取订单明细
      getOrderDetail() {
        this.$axios.get(this.Global.getOrderDetail(this.orderMsg.OrderId)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.orderDetail = res.data.resData;
            this.orderDetail.totalQuantity = 0;
            this.orderDetail.total = 0;
            this.orderDetail.totalOfferFee = 0;
            this.orderDetail.totalAgentCostPrice = 0;
            this.orderDetail.totalSendQuantity = 0;
            this.orderDetail.totalSendPrice = 0;
            // this.orderDetail.AgentDetailList
            for (let i = 0; i < this.orderDetail.AgentDetailList.length; i++) {
              // this.orderDetail.AgentDetailList[]
              this.$set(this.orderDetail.AgentDetailList[i], 'sumPrice', 0);
              this.$set(this.orderDetail.AgentDetailList[i], 'sumAgentCostPrice', 0);
              this.$set(this.orderDetail.AgentDetailList[i], 'sumSendPrice', 0);
              let quantity = this.orderDetail.AgentDetailList[i].Quantity;
              // let totalQuantity = 0, sumPrice, sumAgentCostPrice, sumSendPrice;
              // totalQuantity  = this.Global.addition(totalQuantity , quantity);
              this.orderDetail.totalQuantity = this.orderDetail.totalQuantity + quantity;
              this.orderDetail.AgentDetailList[i].sumPrice = this.Global.subtraction(this.Global.multiplication(this.orderDetail.AgentDetailList[i].UnitPrice, quantity), this.orderDetail.AgentDetailList[i].OfferFee);
              this.orderDetail.total = this.Global.addition(this.orderDetail.total, this.orderDetail.AgentDetailList[i].sumPrice);
              this.orderDetail.totalOfferFee = this.Global.addition(this.orderDetail.totalOfferFee, this.orderDetail.AgentDetailList[i].OfferFee);
              this.orderDetail.AgentDetailList[i].sumAgentCostPrice = this.Global.multiplication(this.orderDetail.AgentDetailList[i].AgentCostPrice, quantity);
              this.orderDetail.totalAgentCostPrice = this.Global.addition(this.orderDetail.totalAgentCostPrice, this.orderDetail.AgentDetailList[i].sumAgentCostPrice);
              this.orderDetail.totalSendQuantity = parseInt(this.Global.addition(this.orderDetail.totalSendQuantity, this.orderDetail.AgentDetailList[i].SendQuantity));
              this.orderDetail.AgentDetailList[i].sumSendPrice = this.Global.multiplication(this.orderDetail.AgentDetailList[i].AgentCostPrice, this.orderDetail.AgentDetailList[i].SendQuantity);
              this.orderDetail.totalSendPrice = this.Global.addition(this.orderDetail.totalSendPrice, this.orderDetail.AgentDetailList[i].sumSendPrice);
            }
            // console.log(this.orderDetail);
            if (this.showType === 'splitOrder') { // 拆单列表
              for (let i = 0; i < 2; i++) {
                let goodsList = [];
                for (let j = 0; j < this.orderMsg.AgentDetailList.length; j++) {
                  // console.log(this.orderDetail.AgentDetailList[j].DetailId);
                  // console.log(this.orderDetail.AgentDetailList[j].SkuId);
                  goodsList.push({
                    DetailId: this.orderDetail.AgentDetailList[j].DetailId,
                    // SkuId: this.orderDetail.AgentDetailList[j].SkuId,
                    GoodsId: this.orderDetail.AgentDetailList[j].GoodsId,
                    GoodsName: this.orderDetail.AgentDetailList[j].GoodsName,
                    // ColorAlias: this.orderDetail.AgentDetailList[j].ColorAlias,
                    Size: this.orderDetail.AgentDetailList[j].Size,
                    Quantity: null
                  });
                }
                this.splitOrderGroupList.push({goodsList: goodsList});
              }
              console.log(this.splitOrderGroupList);
              // this.goodsDetailList = this.orderMsg.AgentDetailList;
            } else if (this.showType === 'modifyReceivingInformation') { // 获取收货信息
              // this.goodsDetailList = this.orderMsg.AgentDetailList;
             this.receiveName = res.data.resData.ReceiveName;
             this.phone = res.data.resData.Phone;
             this.postCode = res.data.resData.PostCode;
             this.selectProvince = res.data.resData.ProvinceId;
             this.selectProvinceName = res.data.resData.ProvinceName;
             this.selectCity = res.data.resData.CityId;
             this.selectCityName = res.data.resData.CityName;
             this.selectArea = res.data.resData.AreaId;
             this.selectAreaName = res.data.resData.AreaName;
             this.address = res.data.resData.Address;
             this.getAllProvinceList();
             this.getCityList();
             this.getAreaList();
           } else if (this.showType === 'changeGoods') {
              if (res.data.resData.AgentDetailList.length > 0) {
                // this.goodsDetailList = this.orderMsg.OrderDetail;
                this.goodsDetailList = [];
                for (let i = 0; i < res.data.resData.AgentDetailList.length; i++) {
                  // console.log('成交单价', res.data.resData.AgentDetailList[i].UnitPrice);
                  this.goodsDetailList.push({
                    DetailId: res.data.resData.AgentDetailList[i].DetailId,
                    IsGeneration: res.data.resData.AgentDetailList[i].IsGeneration,
                    GoodsId: res.data.resData.AgentDetailList[i].GoodsId,
                    GoodsName: res.data.resData.AgentDetailList[i].GoodsName,
                    ColorAlias: res.data.resData.AgentDetailList[i].ColorName,
                    Size: res.data.resData.AgentDetailList[i].Size,
                    MarkPrice: res.data.resData.AgentDetailList[i].MarkPrice,
                    UnitPrice: res.data.resData.AgentDetailList[i].UnitPrice,
                    Quantity: res.data.resData.AgentDetailList[i].Quantity,
                    OfferFee: res.data.resData.AgentDetailList[i].OfferFee
                  });
                }
              } else {
                this.goodsDetailList.push({
                  DetailId: 0,
                  IsGeneration: false,
                  GoodsId: null,
                  GoodsName: null,
                  ColorAlias: null,
                  Size: null,
                  MarkPrice: null,
                  UnitPrice: 0,
                  Quantity: 0,
                  OfferFee: 0
                });
              }
            }
          }
        });
      },

      // 合单操作
      mergeOrder() {
        this.$axios.post(this.Global.mergeOrder, this.orderMsg).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 审核订单
      verifyOrder() {
       /* const params = {
          OrderIds: this.orderMsg,
          LogisticId: this.selectChannelValue
        }; */
        const params = this.orderMsg;
        this.$axios.post(this.Global.verifyOrder, params).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              if (res.data.errorMsg === '部分订单审核失败') {
                this.isMsg = false;
                this.isSuc = false;
                this.txtMsg = '';
                this.errorList = res.data.resData.ErrorOrders;
                this.downloadUrl = res.data.resData.ExcelDownloadUrl;
              } else {
                this.failFun(res.data.errorMsg);
              }
            }
          }
        });
      },

      // 审核单个订单
      verifyOrderSingle() {
        this.$axios.post(this.Global.verifyOrderSingle(this.orderMsg.OrderId), null).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 复制单个订单
      copyOrderSingle() {
        this.$axios.post(this.Global.copyOrderSingle(this.orderMsg.OrderId), null).then((res) => {
          this.isLoading = true;
          if (!res.data.errorMsg.length) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 批量付款
      batchPayOrder() {
        if (!this.securityCode) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入安全密码';
          this.isLoading = false;
          return;
        }
        const params = {
          OrderIds: this.orderMsg,
          securityCode: this.securityCode
        };
        this.$axios.post(this.Global.batchPayOrder, params).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              if (res.data.errorMsg === '部分失败') {
                this.isMsg = false;
                this.isSuc = false;
                this.txtMsg = '';
                this.errorList = res.data.resData.ErrorOrders;
                this.downloadUrl = res.data.resData.ExcelDownloadUrl;
              } else {
                this.failFun(res.data.errorMsg);
              }
            }
          }
        });
      },

      // 全部付款
      payAllOrder() {
        if (!this.securityCode) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入部分密码';
          return;
        }
        const params = {
          securityCode: this.securityCode
        };
        this.$axios.post(this.Global.payAllOrder, params).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              if (res.data.errorMsg === '部分失败') {
                this.isMsg = false;
                this.isSuc = false;
                this.txtMsg = '';
                this.errorList = res.data.resData.ErrorOrders;
                this.downloadUrl = res.data.resData.ExcelDownloadUrl;
              } else {
                this.failFun(res.data.errorMsg);
              }
            }
          }
        });
      },

      // 激活订单
      batchActiveOrder() {
        this.$axios.post(this.Global.batchActiveOrder, this.orderMsg).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              if (res.data.errorMsg === '部分失败.') {
                this.isMsg = false;
                this.isSuc = false;
                this.txtMsg = '';
                this.errorList = res.data.resData.ErrorOrders;
                this.downloadUrl = res.data.resData.ExcelDownloadUrl;
              } else {
                this.failFun(res.data.errorMsg);
              }
            }
          }
        });
      },

      // 激活单个订单
      activeOrderSingle() {
        this.$axios.post(this.Global.activeOrderSingle(this.orderMsg.OrderId)).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 取消订单
      batchCancelOrder() {
        this.$axios.post(this.Global.batchCancelOrder, this.orderMsg).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.isLoading = false;
            this.cancelBtn(true);
          } else {
            if (res.data.errorMsg === '部分失败！') {
              this.isMsg = false;
              this.isSuc = false;
              this.txtMsg = '';
              this.errorList = res.data.resData.ErrorOrders;
              this.downloadUrl = res.data.resData.ExcelDownloadUrl;
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 取消单个订单
      cancelOrderSingle() {
        this.$axios.post(this.Global.cancelOrderSingle(this.orderMsg.OrderId)).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 编辑卖家备注
      editSellerMemo() {
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OrderIds: this.orderMsg,
          SellerMemo: this.sellerRemarks,
          Flag: parseInt(this.flagColor),
          EditType: this.modeType
        };
        this.$axios.post(this.Global.editSellerMemo, params).then((res) => {
            let time = 2;
            const self = this;
            const timer = setInterval(function () {
              clearInterval(timer);
              self.isLoading = false;
              time = --time;
              if (time < 1) {
                if (res) {
                  if (!res.data.errorMsg.length) {
                    self.cancelBtn(true);
                  } else {
                    if (res.data.errorMsg === '调用成功,但部分验证错误') {
                      self.isMsg = false;
                      self.isSuc = false;
                      self.txtMsg = '';
                      self.errorList = res.data.resData.ErrorOrders;
                      self.downloadUrl = res.data.resData.ExcelDownloadUrl;
                    } else {
                      self.failFun(res.data.errorMsg);
                    }
                }
                }
              }
            }, 1000);
        });
      },

      // 编辑单个卖家备注
      editSellerMemoSingle() {
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OrderId: this.orderMsg.OrderId,
          SellerMemo: this.sellerRemarks,
          Flag: parseInt(this.flagColor)
        };
        this.$axios.post(this.Global.editSellerMemoSingle, params).then((res) => {
            let time = 2;
            const self = this;
            const timer = setInterval(function () {
              self.isLoading = false;
              clearInterval(timer);
              time = --time;
              if (time < 1) {
                if (res) {
                  if (!res.data.errorMsg.length) {
                    self.cancelBtn(true);
                  } else {
                    self.failFun(res.data.errorMsg);
                  }
                }
              }
            }, 1000);
        });
      },

      // 编辑内部备注
      editAgentRemark() {
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OrderIds: this.orderMsg,
          AgentRemark: this.internalRemarks,
          EditType: this.modeType
        };
        this.$axios.post(this.Global.editAgentRemark, params).then((res) => {
          let time = 2;
          const self = this;
          const timer = setInterval(function () {
            clearInterval(timer);
            self.isLoading = false;
            time = --time;
            if (time < 1) {
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.cancelBtn(true);
                } else {
                  if (res.data.errorMsg === '调用成功,但部分验证错误') {
                    self.isMsg = false;
                    self.isSuc = false;
                    self.txtMsg = '';
                    self.errorList = res.data.resData.ErrorOrders;
                    self.downloadUrl = res.data.resData.ExcelDownloadUrl;
                  } else {
                    self.failFun(res.data.errorMsg);
                  }
                }
              }
            }
          }, 1000);
        });
      },

      // 编辑单个订单内部备注
      editAgentRemarkSingle() {
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OrderId: this.orderMsg.OrderId,
          AgentRemark: this.internalRemarks
        };
        this.$axios.post(this.Global.editAgentRemarkSingle, params).then((res) => {
          let time = 2;
          const self = this;
          const timer = setInterval(function () {
            clearInterval(timer);
            self.isLoading = false;
            time = --time;
            if (time < 1) {
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.cancelBtn(true);
                } else {
                  self.failFun(res.data.errorMsg);
                }
              }
            }
          }, 1000);
        });
      },

      // 撤回订单
      revokeOrder() {
        this.$axios.post(this.Global.revokeOrder(this.orderMsg.OrderId), null).then((res) => {
          this.isLoading = false;
          if (res) {
            if (!res.data.errorMsg.length) {
              this.cancelBtn(true);
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 智能拆单
      autoSplitOrder() {
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OrderId: this.orderMsg.OrderId
        };
        this.$axios.post(this.Global.autoSplitOrder, params).then((res) => {
          let time = 2;
          const self = this;
          const timer = setInterval(function () {
            clearInterval(timer);
            self.isLoading = false;
            time = --time;
            if (time < 1) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true);
              } else {
                self.failFun(res.data.errorMsg);
              }
            }
          }, 1000);
        });
      },

      // 根据订单号获取可改仓的渠道信息
      getOrderChangeStoreroom() {
        this.$axios.get(this.Global.getOrderChangeStoreroom(this.orderMsg.OrderId)).then((res) => {
          console.log(res);
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            for (let i = 0; i < res.data.resData.length; i++) {
              if (this.channelList[i].name !== '空渠道') {
                this.channelList[i].name = res.data.resData[i].name + '[折扣:' + res.data.resData[i].CostDiscount + '][发货时间:' + this.Filters.timeday(res.data.resData[i].ShipTime) + ']';
              }
            }
            console.log(this.channelList);
            // this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannelValue = this.orderMsg.StoreroomId;
            const channelIndex = this.channelList.findIndex(item => {
              return item.id === this.orderMsg.StoreroomId;
            });
            this.courierCompanyList = this.channelList[channelIndex].logisList;
            this.selectCourierCompany = this.orderMsg.LogisticId;
            // selectCourierCompany
            // courierCompanyList
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 根据渠道id获取物流信息
      forChannelIdGetLogistic() {
        const channelIndex = this.channelList.findIndex(item => {
          return item.id === this.selectChannelValue;
        });
        this.courierCompanyList = this.channelList[channelIndex].logisList;
        if (this.courierCompanyList.length) {
          this.selectCourierCompany = this.courierCompanyList[0].id;
        } else {
          this.selectCourierCompany = '';
        }
      },

      // 保存订单的改仓信息
      saveOrderChangeStoreroom() {
        const params = {
          orderId: this.orderMsg.OrderId,
          storeroomId: this.selectChannelValue,
          logisticId: this.selectCourierCompany
        };
        this.$axios.post(this.Global.saveOrderChangeStoreroom, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 获取渠道下拉框信息
      getAllStoreroomsList() {
        this.$axios.get(this.Global.getAllStoreroomsList).then((res) => {
          if (!res.data.errorMsg) {
            this.channelList = res.data.resData;
            this.channelList.splice(0, 0, {id: '', text: '所有渠道'});
            this.selectChannelValue = '';
          } else {
            this.channelList = [];
            this.selectChannelValue = res.data.errorMsg;
          }
        });
      },

      // 获取快递公司下拉框
      getAllLogisticList() {
        // this.courierCompanyList = [];
        this.$axios.get(this.Global.getAllLogisticList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            this.selectCourierCompany = this.orderMsg.SendLogisticId;
          } else {
            this.courierCompanyList = [];
            this.selectCourierCompany = res.data.errorMsg;
          }
        });
      },

      // 获取快递公司下拉框 -- 待审状态修改物流公司
      getOrderLogisticByOrderId() {
        this.$axios.get(this.Global.getOrderLogisticByOrderId(this.orderMsg.OrderId)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.courierCompanyList = res.data.resData;
            this.selectCourierCompany = this.orderMsg.LogisticId;
          } else {
            this.courierCompanyList = [];
            this.selectCourierCompany = res.data.errorMsg;
          }
        });
      },

      // 保存订单修改物流信息 -- 订单待审修改物流公司
      saveOrderLogistic() {
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          orderId: this.orderMsg.OrderId,
          logisticId: this.selectCourierCompany
        };
        this.$axios.post(this.Global.saveOrderLogistic, params).then((res) => {
          const self = this;
          const timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true);
              } else {
                self.failFun(res.data.errorMsg);
              }
            }
          }, 500);
        });
      },

      // 添加货品里面的删除按钮--删除明细
      delGoodsDetail(i) {
        console.log(this.goodsDetailList);
        if (this.goodsDetailList.length > 1) {
          this.delIndex = i;
          this.isEmbedDialog = true;
          this.embedDialogType = 'sellerRemarksDel';
          this.embedDialogTitle = '提示';
        } else {
          return false;
        }
        // this.goodsDetailList.splice(i, 1);
      },

      // 添加明细
      addGoodsDetail() {
        this.goodsDetailList.push({
          DetailId: 0, // Id
          IsGeneration: false,
          GoodsId: null,
          GoodsName: null,
          ColorAlias: null,
          Size: null,
          MarkPrice: null,
          UnitPrice: 0, // UnitPrice
          Quantity: 0,
          OfferFee: 0 // OfferFee
        });
      },

      // 验证待添加的订单货品
      verifyAppendGoods() {
        let OrderGoodsList = [];
        for (let i = 0; i < this.goodsDetailList.length; i++) {
          if (!this.goodsDetailList[i].GoodsId || !this.goodsDetailList[i].ColorAlias || !this.goodsDetailList[i].Size) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写完整信息';
            return false;
          } else {
            OrderGoodsList.push({
              RowNo: i + 1,
              GoodsId: this.goodsDetailList[i].GoodsId,
              ColorAlias: this.goodsDetailList[i].ColorAlias,
              Size: this.goodsDetailList[i].Size,
              Qty: this.goodsDetailList[i].Quantity
            });
          }
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OrderIdList: this.orderMsg,
          OrderGoodsList: OrderGoodsList
        };
        this.$axios.post(this.Global.verifyAppendGoods, params).then((res) => {
          let time = 1;
          const self = this;
          const timer = setInterval(function () {
            clearInterval(timer);
            self.isLoading = false;
            time = --time;
            if (time < 1) {
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.isEmbedDialog = true;
                  self.embedDialogTitle = '提示';
                  self.embedDialogType = 'addGoods';
                  self.embedDialogMsg = params;
                } else {
                  if (res.data.errorMsg === '验证不通过') {
                    self.isEmbedDialog = true;
                    self.embedDialogTitle = '提示';
                    self.embedDialogType = 'addGoodsValidatuionFailed';
                    self.embedDialogMsg = res.data.resData;
                  } else {
                    self.failFun(res.data.errorMsg);
                  }
                }
              }
            }
          }, 1000);
        });
      },

      // 添加订单货品
      appendGoods(params) {
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.post(this.Global.appendGoods, params).then((res) => {
          let times = 2;
          const self = this;
          const timer = setInterval(function () {
            self.isLoading = false;
            clearInterval(timer);
            times = --times;
            if (times < 1) {
              if (res) {
                if (!res.data.errorMsg.length) {
                  self.cancelBtn(true);
                } else {
                  if (res.data.errorMsg === '部分订单因为状态不符导致操作失败.') {
                    self.isMsg = false;
                    self.isSuc = false;
                    self.txtMsg = '';
                    self.errorList = res.data.resData.ErrorOrders;
                    self.downloadUrl = res.data.resData.ExcelDownloadUrl;
                  } else {
                    self.failFun(res.data.errorMsg);
                  }
                }
              }
            }
          });
        });
      },

      // 判断数量是否为正整数
      quantityInteger(e, index) {
        const integer = new RegExp('^[1-9][0-9]*$').test(e.target.value);
        if (parseInt(this.goodsDetailList[index].Quantity) !== 0) {
          if (!integer) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请输入等于零或大于零的正整数';
            this.goodsDetailList[index].Quantity = 1;
          }
        }
      },

      // 输入大于等于零的正数
      greaterThanZero(val, index, type) {
        const reg = /^\d+(?=\.{0,1}\d+$|$)/;
        if (!val) {
          if (type === 'discount') {
            this.goodsDetailList[index].OfferFee = 0;
          } else {
            this.goodsDetailList[index].UnitPrice = 0;
          }
        } else if (!reg.test(val) || !val) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入等于零或大于的正数';
          if (type === 'discount') {
            this.goodsDetailList[index].OfferFee = 0;
          } else {
            this.goodsDetailList[index].UnitPrice = 0;
          }
        }
      },

      // 改货 根据货号获取品名和零售价
      getGoodsInfoByGoodsId(val, index) {
        this.$axios.post(this.Global.getGoodsInfoByGoodsId(val), null).then((res) => {
          if (!res.data.errorMsg.length) {
            // this.goodsDetailList[index].Quantity = 0;
            // this.goodsDetailList[index].UnitPrice = 0;
            this.goodsDetailList[index].GoodsName = res.data.resData.GoodsName;
            this.goodsDetailList[index].MarkPrice = res.data.resData.MarketPrice;
          } else {
            // this.goodsDetailList[index].Quantity = null;
            // this.goodsDetailList[index].UnitPrice = null;
            this.goodsDetailList[index].GoodsName = null;
            this.goodsDetailList[index].MarkPrice = null;
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = res.data.errorMsg;
          }
        });
      },

      // 保存改货信息
      saveChangeGoods() {
        let detailSum = 0; // 添加明细里的总数
        let preferentialPriceSum = 0; // 添加明细里的优惠价总数
        let OrderGoodsList = [];
        for (let i = 0; i < this.goodsDetailList.length; i++) {
          if (this.goodsDetailList[i].Quantity === 0) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '数量不能为零';
            return false;
          } else if (!this.goodsDetailList[i].GoodsId || !this.goodsDetailList[i].Size) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '请填写完整信息（请注意货号跟尺码）';
            return false;
          } else {
            // console.log(detailSum);
            // console.log(parseFloat(this.goodsDetailList[i].UnitPrice) * parseFloat(this.goodsDetailList[i].Quantity)) - parseFloat(this.goodsDetailList[i].OfferFee);
            detailSum = this.Global.addition(detailSum, this.Global.multiplication(this.goodsDetailList[i].UnitPrice, this.goodsDetailList[i].Quantity));
            preferentialPriceSum = this.Global.addition(preferentialPriceSum, this.goodsDetailList[i].OfferFee);
           /* detailSum = this.Global.subtraction(this.Global.addition(detailSum,
              this.Global.multiplication(this.goodsDetailList[i].UnitPrice, this.goodsDetailList[i].Quantity)),
              this.goodsDetailList[i].OfferFee); */

            OrderGoodsList.push({
              // OrderId: this.orderMs买家IDg.OrderId,
              DetailId: this.goodsDetailList[i].DetailId,
              GoodsId: this.goodsDetailList[i].GoodsId,
              // GoodsName: this.goodsDetailList[i].GoodsName,
              // RowNo: i,
              ColorAlias: this.goodsDetailList[i].ColorAlias,
              Size: this.goodsDetailList[i].Size,
              UnitPrice: this.goodsDetailList[i].UnitPrice,
              OfferFee: this.goodsDetailList[i].OfferFee,
              Quantity: this.goodsDetailList[i].Quantity
              // SkuId: null
            });
          }
        }
        // console.log('改货值', this.orderDetail.TotalAmount, detailSum, this.Global.addition(detailSum, this.orderDetail.TotalAmount), Number(this.Global.addition(detailSum, this.orderDetail.TotalAmount)));
        // console.log('明细成交价总和不等于货品成交价: ', this.orderDetail.TotalAmount, detailSum, Number(detailSum));
        if (this.orderDetail.TotalAmount !== Number(detailSum)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '明细成交价总和不等于货品成交价，请重新核对';
          return;
        }
        if (this.orderDetail.OfferAmount !== Number(preferentialPriceSum)) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '明细优惠价总和不等于货品总优惠价，请重新核对';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        const params = {
          OrderId: this.orderMsg.OrderId,
          OrderGoodsList: OrderGoodsList
        };
        this.$axios.post(this.Global.saveChangeGoods, params).then((res) => {
          const self = this;
          const timer = setTimeout(function () {
            clearInterval(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                // self.isMsg = true;
                // self.isSuc = true;
                // self.txtMsg = '操作成功';
                self.cancelBtn(true);
              } else {
                if (res.data.errorMsg === 'SKU校验失败') {
                  self.isEmbedDialog = true;
                  self.embedDialogTitle = '提示';
                  self.embedDialogType = 'validatuionFailed';
                  self.embedDialogMsg = res.data.resData;
                } else if (res.data.errorMsg === '库存不足') {
                  self.isEmbedDialog = true;
                  self.embedDialogTitle = '提示';
                  self.embedDialogType = 'insufficientInventory';
                  self.embedDialogMsg = res.data.resData;
                } else {
                  self.failFun(res.data.errorMsg);
                }
              }
            }
          }, 100);
        });
      },

      // 拆单--添加新订单
      addSplitOrder() {
        const goodsList = [];
        for (let i = 0; i < this.orderDetail.AgentDetailList.length; i++) {
          goodsList.push({
            DetailId: this.orderDetail.AgentDetailList[i].DetailId,
            // SkuId: this.orderDetail.AgentDetailList[i].SkuId,
            GoodsId: this.orderDetail.AgentDetailList[i].GoodsId,
            GoodsName: this.orderDetail.AgentDetailList[i].GoodsName,
            // ColorAlias: this.orderDetail.AgentDetailList[i].ColorAlias,
            Size: this.orderDetail.AgentDetailList[i].Size,
            Quantity: null
          });
        }
        this.splitOrderGroupList.push({goodsList: goodsList});
        // this.splitOrderGroupList[this.splitOrderGroupList.length - 1].goodsList
      },

      // 删除拆单里面的的订单
      delSplitOrder(pIndex, index) {
        if (this.splitOrderGroupList.length === 1 && this.splitOrderGroupList[0].goodsList.length === 1) {
          return false;
        } else {
          this.splitOrderGroupList[pIndex].goodsList.splice(index, 1);
          if (!this.splitOrderGroupList[pIndex].goodsList.length) {
            this.splitOrderGroupList.splice(pIndex, 1);
          }
        }
      },

      // 验证是否为正整数
      positiveInteger(e, pIndex, index) {
        const integer = new RegExp('^[1-9][0-9]*$').test(e.target.value);
        if (!integer) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请输入正整数';
          this.splitOrderGroupList[pIndex].goodsList[index].Quantity = 1;
        }
      },

      // 拆分订单--提交
      manualSplitOrder() {
        let splitOrder = [];
        for (let i = 0; i < this.orderDetail.AgentDetailList.length; i++) { // 遍历原本的订单的货品明细
          splitOrder.push({
            DetailId: this.orderDetail.AgentDetailList[i].DetailId,
            GoodsId: this.orderDetail.AgentDetailList[i].GoodsId,
            // SkuId: this.orderDetail.AgentDetailList[i].SkuId,
            Quantity: 0
          });
          for (let j = 0; j < this.splitOrderGroupList.length; j++) { // 遍历拆单的条数
            for (let k = 0; k < this.splitOrderGroupList[j].goodsList.length; k++) { // 遍历拆单里的详细货品信息
              if (this.splitOrderGroupList[j].goodsList[k].Quantity) {
                if ((splitOrder[i].GoodsId === this.splitOrderGroupList[j].goodsList[k].GoodsId) &&
                  (splitOrder[i].DetailId === this.splitOrderGroupList[j].goodsList[k].DetailId)) { // 判断货号是否相同
                  // 计算
                  splitOrder[i].Quantity = splitOrder[i].Quantity + parseInt(this.splitOrderGroupList[j].goodsList[k].Quantity);
                }
              } else {
                this.isMsg = true;
                this.isSuc = false;
                this.txtMsg = '请填写完整';
                return;
              }
            }
          }
        }
        let flag = true;
        for (let i = 0; i < this.orderDetail.AgentDetailList.length; i++) { // 判断数量是否相等
          console.log(this.orderDetail.AgentDetailList[i].Quantity);
          console.log(splitOrder[i].Quantity);
          if (this.orderDetail.AgentDetailList[i].Quantity !== splitOrder[i].Quantity) {
            this.isMsg = true;
            this.isSuc = false;
            this.txtMsg = '拆单后的订单合并一起应与原订单一致，请重新核对';
            return;
          }
        }

        if (!flag) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '拆单后的订单合并一起应与原订单一致，请重新核对';
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          let SplitOrderGroupList = [];
          let SplitOrderDetail = [];
          for (let i = 0; i < this.splitOrderGroupList.length; i++) {
            SplitOrderDetail = [];
            for (let j = 0; j < this.splitOrderGroupList[i].goodsList.length; j++) {
              SplitOrderDetail.push({
                Id: this.splitOrderGroupList[i].goodsList[j].DetailId,
                GoodsId: this.splitOrderGroupList[i].goodsList[j].GoodsId,
                Quantity: this.splitOrderGroupList[i].goodsList[j].Quantity
              });
            }
            SplitOrderGroupList.push({SplitOrderDetail: SplitOrderDetail});
          }
          const params = {
            OrderId: this.orderDetail.OrderId,
            SplitOrderGroupList: SplitOrderGroupList
            // SplitOrderGroupList: SplitOrderDetail
          };
          this.$axios.post(this.Global.manualSplitOrder, params).then((res) => {
            this.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                this.cancelBtn(true);
              } else {
                this.failFun(res.data.errorMsg);
              }
            }
          });
        }
      },

      // 查看拆分订单信息
      viewSplitOrderInfo() {
        this.$axios.post(this.Global.viewSplitOrderInfo(this.orderMsg.OrderId)).then((res) => {
          if (!res.data.errorMsg.length) {
            console.log(res.data.resData);
            this.splitOrderDetailList = res.data.resData;
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 渠道重配 --- 单个
      resetOrderStoreroom() {
        this.$axios.post(this.Global.resetOrderStoreroom(this.orderMsg[0]), null).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 渠道重配
      batchResetOrderStoreroom() {
        this.$axios.post(this.Global.batchResetOrderStoreroom, this.orderMsg).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            if (res.data.errorMsg === '部分失败') {
              this.isMsg = false;
              this.isSuc = false;
              this.txtMsg = '';
              this.errorList = res.data.resData.errorData;
              this.downloadUrl = res.data.resData.resData;
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 获取省份下拉框
      getAllProvinceList() {
        this.$axios.get(this.Global.getAllProvinceList).then((res) => {
          if (!res.data.errorMsg.length) {
            this.provincesList = res.data.resData;
          }
        });
      },

      // 获取省份名称
      getProvinceName(vId) {
        let obj = {};
        obj = this.provincesList.find((item) => {
          return item.id === vId;
        });
        this.selectProvinceName = obj.text;
      },

      // 获取城市下拉框----下拉框改变触发的
      getAllCityList(vId) {
        this.selectCity = null;
        this.selectCityName = null;
        this.selectArea = null;
        this.selectAreaName = null;
        this.getCityList();
        this.getProvinceName(vId);
      },

      // 获取城市下拉框
      getCityList() {
        if (this.selectProvince) {
          this.$axios.get(this.Global.getAllCityList(this.selectProvince)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.cityList = res.data.resData;
            }
          });
        }
      },

      // 获取城市名称
      getCityName(vId) {
        let obj = {};
        obj = this.cityList.find((item) => {
          return item.id === vId;
        });
        this.selectCityName = obj.text;
      },

      // 获取区下拉框
      getAllAreaList(vId) {
        this.getAreaList();
        this.getCityName(vId);
      },

      // 获取区下拉框----下拉框改变触发的
      getAreaList() {
        if (this.selectCity) {
          this.$axios.get(this.Global.getAllAreaList(this.selectCity)).then((res) => {
            if (!res.data.errorMsg.length) {
              this.areaList = res.data.resData;
            }
          });
        }
      },

      // 获取区的名称
      getAreaName(vId) {
        let obj = {};
        obj = this.areaList.find((item) => {
          return item.id === vId;
        });
        this.selectAreaName = obj.text;
      },

      // 智能地址录入
      intelligentAddressEntry() {
        this.isEmbedDialog = true;
        this.embedDialogType = 'intelligentAddressEntry';
        this.embedDialogMsg = this.intelligentAddress;
      },

      // 手机号正则表达式
      phoneCheck (num) {
        // /^1(3|4|5|7|8)\d{9}$/
        const reg = /^[1][0-9]\d{9}$|^([6|9])\d{7}$|^[0][9]\d{8}$|^[6]([8|6])\d{5}$/;
        // const reg = /^1([34578])\d{9}$/;
        return reg.test(num);
      },

      // 保存收货信息
      saveReceiveInfo() {
        if (!this.receiveName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写收货人';
        } else if (!this.phone) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写联系电话';
        } else if (!this.selectProvince || !this.selectProvinceName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择省份';
        } else if (!this.selectCity || !this.selectCityName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择城市';
          /* else if (!this.selectArea || !this.selectAreaName) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择城区';
        } */
        } else if (!this.address) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写详细地址';
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          const params = {
            OrderId: this.orderMsg.OrderId,
            ReceiveName: this.receiveName,
            Phone: this.phone,
            PostCode: this.postCode,
            ProviceId: this.selectProvince,
            ProvinceName: this.selectProvinceName,
            CityId: this.selectCity,
            CityName: this.selectCityName,
            AreaId: this.selectArea,
            AreaName: this.selectAreaName,
            Address: this.address
          };
          this.$axios.post(this.Global.saveReceiveInfo, params).then((res) => {
            let time = 3;
            const self = this;
            const timer = setInterval(function () {
              clearInterval(timer);
              self.isLoading = false;
              if (time > 1) {
                time = --time;
                if (res) {
                  if (!res.data.errorMsg.length) {
                    self.cancelBtn(true);
                  } else {
                    self.failFun(res.data.errorMsg);
                  }
                }
              }
            }, 1000);
          });
        }
      },

      // 修改单个订单的卖家留言和分销内部备注
      editRemarkMemoByOrderId() {
        const params = {
          OrderId: this.orderMsg.OrderId,
          SellerMemo: this.sellerRemarks,
          Flag: parseInt(this.flagColor),
          AgentRemark: this.internalRemarks
        };
        this.$axios.post(this.Global.editRemarkMemoByOrderId, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 批量编辑订单内部备注（分销商备注）
      batchEditAgentRemark() {
        const params = {
          OrderIds: this.orderMsg,
          AgentRemark: this.internalRemarks,
          EditType: parseInt(this.modeType)
        };
        this.$axios.post(this.Global.batchEditAgentRemark, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 批量编辑卖家备注
      batchEditSellerMemo() {
        const params = {
          OrderIds: this.orderMsg,
          SellerMemo: this.sellerRemarks,
          Flag: parseInt(this.flagColor),
          EditType: parseInt(this.modeType)
        };
        this.$axios.post(this.Global.batchEditSellerMemo, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            if (res.data.errorMsg === '部分失败') {
              this.isMsg = false;
              this.isSuc = false;
              this.txtMsg = '';
              this.errorList = res.data.resData.ErrorOrders;
              this.downloadUrl = res.data.resData.ExcelDownloadUrl;
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 获取订单成本
      getOrderCost() {
        const params = {
          OrderId: this.orderMsg.OrderId
        };
        this.$axios.post(this.Global.getOrderCost, params).then((res) => {
          if (!res.data.resData.errorMsg) {
            this.costPrice = res.data.resData.CostPrice;
          }
        });
      },

      // 成本价页面关闭
      closePage() {
        if (this.showType === 'costPrice') {
          this.cancelBtn(false);
        }
      },

      // 分销商根据订单号修改物流运单号
      editOrderExpressInfo() {
        if (!this.selectCourierCompany) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请选择一个物流公司';
          return;
        } else if (!this.ExpressNum) {
          this.isMsg = true;
          this.isSuc = false;
          this.txtMsg = '请填写运单号';
          return;
        }
        this.isLoading = true;
        this.loadingType = 'options';
        this.$axios.post(this.Global.editOrderExpressInfo(this.orderMsg.OrderId, this.selectCourierCompany, this.ExpressNum), null).then((res) => {
          const self = this;
          const timer = setTimeout(function () {
            clearTimeout(timer);
            self.isLoading = false;
            if (res) {
              if (!res.data.errorMsg.length) {
                self.cancelBtn(true);
              } else {
                self.failFun(res.data.errorMsg);
              }
            }
          }, 500);
        });
      },

      // 取消订单同步失败标记
      cancelOrderAsyncFailFlag() {
        this.$axios.post(this.Global.cancelOrderAsyncFailFlag(this.orderMsg.OrderId), null).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 获取一条订单明细中可用的渠道信息
      getOrderDetailStoreroomInfo() {
        this.$axios.post(this.Global.getOrderDetailStoreroomInfo(this.orderMsg.OrderId, this.orderMsg.DetailId), null).then((res) => {
          if (!res.data.errorMsg.length) {
            this.goodInventoryMsg = res.data.resData;
            // this.goodInventoryMsgErrTxt = null;
          } else {
            this.failFun(res.data.errorMsg);
            // this.goodInventoryMsgErrTxt = res.data.errorMsg;
          }
        });
      },

      // 获取一个订单所有明细中可用的渠道信息
      getOrderAllDetailStoreroomInfo() {
        this.$axios.get(this.Global.getOrderAllDetailStoreroomInfo(this.orderMsg.OrderId)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.goodInventoryMsg = res.data.resData;
            // this.goodInventoryMsgErrTxt = null;
          } else {
            // this.goodInventoryMsgErrTxt = res.data.errorMsg;
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 获取订单日志
      getOrderLogs() {
        this.$axios.post(this.Global.getOrderLogs(this.orderMsg.OrderId)).then((res) => {
          if (!res.data.errorMsg.length) {
            this.logList = res.data.resData;
          } else {
            this.failFun(res.data.errorMsg);
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.cancelBtn(false);
              clearTimeout(timer);
            }, 3000);
          }
        });
      },

      // 对账导出
      exportOrderExcel() {
        const params = this.orderMsg;
        this.$axios.post(this.Global.exportOrderExcel(this.formatValue), params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
            // this.goodInventoryMsgErrTxt = null;
          } else {
            // this.goodInventoryMsgErrTxt = res.data.errorMsg;
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 导出明细
      exportDetailExcel() {
        const params = this.orderMsg;
        this.$axios.post(this.Global.exportDetailExcel(this.formatValue), params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            window.open(res.data.resData, '_blank');
            // this.goodInventoryMsgErrTxt = null;
          } else {
            // this.goodInventoryMsgErrTxt = res.data.errorMsg;
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 批量同步订单的线上发货信息
      syncOnlineOrderSend() {
        const params = this.orderMsg;
        this.$axios.post(this.Global.syncOnlineOrderSend, params).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.logList = res.data.resData;
          } else {
            this.failFun(res.data.errorMsg);
            let timer;
            const self = this;
            timer = setTimeout(function () {
              self.cancelBtn(false);
              clearTimeout(timer);
            }, 3000);
          }
        });
      },

      // 批量撤回 batchPullBack
      batchRevokeOrder() {
        this.$axios.post(this.Global.batchRevokeOrder, this.orderMsg).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            this.failFun(res.data.errorMsg);
          }
        });
      },

      // 一键审单
      verifyAllOrder() {
        this.$axios.post(this.Global.verifyAllOrder, null).then((res) => {
          this.isLoading = false;
          if (!res.data.errorMsg.length) {
            this.cancelBtn(true);
          } else {
            if (res.data.errorMsg === '部分订单审核失败') {
              this.isMsg = false;
              this.isSuc = false;
              this.txtMsg = '';
              this.errorList = res.data.resData.ErrorOrders;
              this.downloadUrl = res.data.resData.ExcelDownloadUrl;
            } else {
              this.failFun(res.data.errorMsg);
            }
          }
        });
      },

      // 提交按钮
      submitBtn() {
     /* else if (this.showType === 'internalRemarks') { // 内部备注
          if (this.isBatch) {
            this.editAgentRemark();
          } else {
            this.editAgentRemarkSingle();
          }
        } else if (this.showType === 'sellerRemarks') { // 卖家备注
          if (this.isBatch) {
            this.editSellerMemo();
          } else {
            this.editSellerMemoSingle();
          }
        } */
        if (this.showType === 'modifyLogistic') { // 修改物流信息
          this.editOrderExpressInfo();
        } else if (this.showType === 'modifyLogisticPending') { // 保存订单修改物流信息 -- 订单待审修改物流公司
          this.saveOrderLogistic();
        } else if (this.showType === 'changeGoods') { // 改货
          this.saveChangeGoods();
        } else if (this.showType === 'modifyReceivingInformation') { // 编辑收货信息
          this.saveReceiveInfo();
        } else if (this.showType === 'intelligentSplitOrder') {
          this.autoSplitOrder();
        } else {
          this.isLoading = true;
          this.loadingType = 'options';
          let time = 1;
          const self = this;
          const timer = setInterval(function () {
            time = --time;
            if (time < 1) {
              if (self.showType === 'mergerOrder') {
                self.mergeOrder();
              } else if (self.showType === 'batchAudit') {
                if (self.isBatch) {
                  self.verifyOrder();
                } else {
                  self.verifyOrderSingle();
                }
              } else if (self.showType === 'copyOrder') {
                self.copyOrderSingle();
              } else if (self.showType === 'activationOrder') {
                if (self.isBatch) {
                  self.batchActiveOrder();
                } else {
                  self.activeOrderSingle();
                }
              } else if (self.showType === 'internalRemarks') {
                self.batchEditAgentRemark();
              } else if (self.showType === 'sellerRemarks') {
                self.batchEditSellerMemo();
              } else if (self.showType === 'cancelOrder') {
                if (self.isBatch) {
                  self.batchCancelOrder();
                } else {
                  self.cancelOrderSingle();
                }
              } else if (self.showType === 'pullBack') {
                self.revokeOrder();
              } else if (self.showType === 'changeWarehouse') {
                self.saveOrderChangeStoreroom();
              } else if (self.showType === 'channelOrder') {
                if (self.isBatch) {
                  self.batchResetOrderStoreroom();
                } else {
                  self.resetOrderStoreroom();
                }
              } else if (self.showType === 'addOrder') {
                self.isEmbedDialog = true;
                self.embedDialogType = 'sellerRemarksSub';
                self.embedDialogTitle = '提示';
              } else if (self.showType === 'batchPayment') {
                self.batchPayOrder();
              } else if (self.showType === 'allPayment') {
                self.payAllOrder();
              } else if (self.showType === 'remarks') {
                self.editRemarkMemoByOrderId();
              } else if (self.showType === 'synchronizationFailureFlag') {
                self.cancelOrderAsyncFailFlag();
              } else if (self.showType === 'accountsExport') {
                self.exportOrderExcel();
              } else if (self.showType === 'detailExport') {
                self.exportDetailExcel();
              } else if (self.showType === 'syncOnlineOrderSend') {
                self.syncOnlineOrderSend();
              } else if (self.showType === 'aCheckList') {
                self.verifyAllOrder();
              } else if (self.showType === 'batchPullBack') {
                self.batchRevokeOrder();
              }
              clearInterval(timer);
            }
          }, 500);
        }
      },

      // 下载导出地址
      downloadUrlFun() {
        window.open(this.downloadUrl, '_blank');
      },

      // 取消按钮
      cancelBtn(type) {
        this.$emit('cancelbtn', {isShow: false, showType: this.showType, handleType: type});
      },

      // 接收提示框传送的数据
      closeMsgDialog(e) {
        this.isMsg = e;
      },

      // 失败执行的方法
      failFun(txt) {
        this.isLoading = false;
        this.isMsg = true;
        this.isSuc = false;
        this.txtMsg = txt;
        let time = 3;
        const self = this;
        const timer = setInterval(function () {
          time = --time;
          if (time < 1) {
            self.isMsg = false;
            clearInterval(timer);
          }
        }, 1000);
      },

      // 接收嵌入框的返回的数据
      getEmbedDialogMsg(e) {
        this.isEmbedDialog = e.isShow;
        if (e.handleType) {
          if (this.embedDialogType === 'sellerRemarksDel') {
            this.goodsDetailList.splice(this.delIndex, 1);
          } else if (this.embedDialogType === 'addGoods') { // 添加货品
            this.appendGoods(e.orderMsg);
          } else if (e.showType === 'intelligentAddressEntry') { // 智能地址录入
            this.intelligentAddress = e.address.addressContent;
            this.receiveName = e.address.name;
            this.phone = e.address.phone;
            this.postCode = e.address.postCode;
            // this.address = e.address.provinceName + e.address.cityName + e.address.areaName;
            this.address = e.address.addressContent;
            this.selectProvince = e.address.provinceId;
            this.selectProvinceName = e.address.provinceName;
            this.$axios.get(this.Global.getAllCityList(this.selectProvince)).then((res) => {
              if (!res.data.errorMsg.length) {
                this.cityList = res.data.resData;
                this.selectCity = e.address.cityId;
                this.selectCityName = e.address.cityName;

                this.$axios.get(this.Global.getAllAreaList(this.selectCity)).then((areaRes) => {
                  if (!areaRes.data.errorMsg.length) {
                    this.areaList = areaRes.data.resData;
                    this.selectArea = e.address.areaId;
                    this.selectAreaName = e.address.areaName;
                  }
                });
              }
            });
          }
        }
      }
    },
    created() {
      if (this.showType === 'orderDetail') {
        this.getOrderDetail();
      } else if (this.showType === 'changeWarehouse') { // 改仓
        this.getOrderChangeStoreroom();
      } else if (this.showType === 'addOrder') { // 添加货品
        this.addGoodsDetail();
      } else if (this.showType === 'costPrice') { // 成本价
        this.getOrderCost();
      } else if (this.showType === 'remarks') { // 改备注
        // this.getOrderCost();
        this.flagColor = this.orderMsg.Flag;
        this.sellerRemarks = this.orderMsg.SellerMemo;
        this.internalRemarks = this.orderMsg.AgentRemark;
      } else if (this.showType === 'changeGoods') { // 改货
        this.getOrderDetail();
        if (this.orderMsg.AgentDetailList && this.orderMsg.AgentDetailList.length > 0) {
          // this.goodsDetailList = this.orderMsg.OrderDetail;
          this.goodsDetailList = [];
          for (let i = 0; i < this.orderMsg.AgentDetailList.length; i++) {
            // console.log('成交单价', this.orderMsg.AgentDetailList[i].UnitPrice);
            this.goodsDetailList.push({
              DetailId: this.orderMsg.AgentDetailList[i].DetailId,
              IsGeneration: this.orderMsg.AgentDetailList[i].IsGeneration,
              GoodsId: this.orderMsg.AgentDetailList[i].GoodsId,
              GoodsName: this.orderMsg.AgentDetailList[i].GoodsName,
              ColorAlias: this.orderMsg.AgentDetailList[i].ColorAlias,
              Size: this.orderMsg.AgentDetailList[i].Size,
              MarkPrice: this.orderMsg.AgentDetailList[i].MarkPrice,
              UnitPrice: this.orderMsg.AgentDetailList[i].UnitPrice,
              Quantity: this.orderMsg.AgentDetailList[i].Quantity,
              OfferFee: this.orderMsg.AgentDetailList[i].OfferFee
            });
          }
        } else {
          this.goodsDetailList.push({
            DetailId: 0,
            IsGeneration: false,
            GoodsId: null,
            GoodsName: null,
            ColorAlias: null,
            Size: null,
            MarkPrice: null,
            UnitPrice: 0,
            Quantity: 0,
            OfferFee: 0
          });
        }
      } else if (this.showType === 'splitOrder') { // 拆单明细
        this.getOrderDetail();
      } else if (this.showType === 'modifyReceivingInformation') { // 编辑收获地址
        this.getOrderDetail();
      } else if (this.showType === 'sellerRemarks' && !this.isBatch) { // 卖家备注----单个
        this.sellerRemarks = this.orderMsg.SellerMemo;
        this.flagColor = this.orderMsg.Flag;
      } else if (this.showType === 'internalRemarks' && !this.isBatch) { // 内部备注----单个
        this.internalRemarks = this.orderMsg.AgentRemark;
      } else if (this.showType === 'splitOrderDetail') { // 拆单详情
        this.viewSplitOrderInfo();
      } else if (this.showType === 'checkLog') {
        this.getOrderLogs();
      } else if (this.showType === 'modifyLogistic') {
        this.getAllLogisticList();
        this.ExpressNum = this.orderMsg.ExpressNum;
      } else if (this.showType === 'modifyLogisticPending') {
        this.getOrderLogisticByOrderId();
      } else if (this.showType === 'orderDetailInventory') {
        // console.log(this.orderMsg);
        // this.getOrderDetailStoreroomInfo();
        this.getOrderAllDetailStoreroomInfo();
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../../assets/css/home-view";

  .order_list_embed_msg {
    background-color: #fff;
    max-height: 100%;

    &.w_percent96 {
      width: 96%;
    }

    textarea {
      padding: 5px;
    }

    .select_dialog_embed_box {
      width: 100%;
    }

    .text_center {
      text-align: center!important;
    }

    .maxH_400 {
      max-height: 400px!important;
    }

    /*合并订单*/
    .merger_order {
      p {
        margin: 30px 20px 0;

        &:last-child {
          margin: 0 20px 40px;
          width: 400px;
        }
      }
    }

    /*审单*/
    .batch_audit {
      margin: 30px 35px 0;

      i {
        font-style: normal;
        font-size: 12px;
        color: red;
      }
    }

    /*部分审单失败*/
    .batch_audit_fail {
      width: 700px;
      margin-top: 10px;

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;

            &:first-child {
              white-space: nowrap;
            }
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 460px;
          overflow-y: auto;
        }
      }
    }

    /*添加货品*/
    .add_order {
      width: 712px;
      padding: 0 10px;

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;

            &:nth-child(1) {
              width: 200px;
            }

            &:nth-child(2), &:nth-child(3), &:nth-child(4) {
              width: 100px;
            }
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 460px;
          overflow-y: auto;
        }
      }
    }

    /*渠道重配--部分错误*/
    .channel_order_failed {
      width: 550px;

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 440px;
          overflow-y: auto;
        }
      }
    }

    /*日志*/
    .check_log {
      width: 850px;
      max-height: 500px;
      overflow-y: auto;

      .table {
        margin: 0 auto;

       /* thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;

            &:first-child, &:last-child {
              width: 25%;
            }
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 440px;
          overflow-y: auto;
        } */
      }
    }

    /*卖家备注 / 内部备注*/
    .seller_remark, .internal_remarks {
      padding: 20px 10px 10px 30px;

      div {
        input[type='radio'] {
          margin-right: 3px;

          &:hover {
            cursor: pointer;
          }
        }

        img {
          margin-right: 5px;
        }

        label {
          margin-right: 8px;
        }
      }

      textarea {
        width: 475px;
        height: 100px;
      }
    }

    /*订单详情*/
    .order_detail {
      padding: 5px;

      .order_detail_content {
        .table {
          th {
            text-align: right;
          }

          td {
            text-align: left;
          }
        }
      }

      .order_detail_goods {
        .table {
          margin: 0 auto;

          thead, tbody tr {
            display: table;
            width: 100%;
            table-layout: fixed;

            th, td {
              padding: 10px;
              width: 10%;
            }
          }

          tbody {
            display: block;
            width: 100%;
            max-height: 127px;
            overflow-y: scroll;
            /*overflow-y: auto;*/
          }

          &.detail_tb {
            td {
              /*border: 1px solid #dddddd;*/
              border-top: none;
              word-wrap: break-word;
              word-break: break-all;

              &:first-child {
                /*border-left: none;*/
              }

              &:last-child {
                border-right: none;
              }
            }
          }
        }
      }
    }

    /*改仓*/
    .change_warehouse {
      & > div {
        /*width: 240px;*/
        width: 300px;
        text-align: center;
        margin-left: auto;
        margin-right: auto;
        box-shadow: 1px 1px 2px;
      }
    }

    /*改货*/
    .change_goods {
      padding: 10px 10px 0;

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;
            width: 10%;
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 400px;
          overflow-y: auto;
        }
      }
    }

    /*拆单*/
    .split_order {
      padding: 10px;
      max-height: 510px;
      overflow-y: auto;

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;
          }
        }

        tbody {
          display: block;
          width: 100%;
          /*max-height: 105px;*/
          overflow-y: auto;
        }
      }
    }

    /*编辑收货信息*/
    .modify_receiving_information {
      padding: 25px 15px 10px 30px;

      & > div {
        margin-bottom: 10px;

        & > div {
          width: 58%;
        }
      }

      span {
        display: inline-block;
        width: 70px;
        text-align: right;
      }
    }

    /*缺货信息*/
    .out_of_stock_information {

      .table {
        margin: 0 auto;

        thead, tbody tr {
          display: table;
          width: 100%;
          table-layout: fixed;

          th, td {
            padding: 10px;
          }
        }

        tbody {
          display: block;
          width: 100%;
          max-height: 440px;
          overflow-y: auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/home/sales-management/order-list-embed-msg.vue